// extracted by mini-css-extract-plugin
export default {"sectionHeading":"AcademyProjectModalCreateStage_sectionHeading__k4D8V","inputField":"AcademyProjectModalCreateStage_inputField__Ehsev"};